import React, { createContext, useCallback, useContext, useState } from 'react';

type CurrentMemberNavContextValue = {
  memberDisplayName: string | null;
  setMemberDisplayName: (name: string | null) => void;
};

function defaultSetMemberDisplayName(_name: string | null): void {
  // Default no-op when outside provider
}

const CurrentMemberNavContext = createContext<CurrentMemberNavContextValue>({
  memberDisplayName: null,
  setMemberDisplayName: defaultSetMemberDisplayName,
});

type CurrentMemberNavProviderProps = {
  children: React.ReactNode;
};

export const CurrentMemberNavProvider: React.FC<
  CurrentMemberNavProviderProps
> = ({ children }) => {
  const [memberDisplayName, setMemberDisplayName] = useState<string | null>(
    null,
  );
  const value: CurrentMemberNavContextValue = {
    memberDisplayName,
    setMemberDisplayName: useCallback((name: string | null) => {
      setMemberDisplayName(name);
    }, []),
  };
  return (
    <CurrentMemberNavContext.Provider value={value}>
      {children}
    </CurrentMemberNavContext.Provider>
  );
};

export const useCurrentMemberNav = (): CurrentMemberNavContextValue =>
  useContext(CurrentMemberNavContext);
